export default __webpack_public_path__ + "static/media/(27).600def78.jpeg";